import {
  IArrangeTextTask,
  IArrangeTextTaskSession,
  IAssignmentTask,
  IAssignmentTaskSession,
  ICheckFillInBlanksTask,
  ICheckTrueFalseTask,
  IFillInBlanksTaskSession,
  IFillInTableTask,
  IFillInTableTaskSession,
  IInlineDropdownTask,
  IInlineDropdownTaskSession,
  IMultipleChoiceTask,
  IMultipleChoiceTaskSession,
  ITrueFalseTaskSession,
  tCheckTaskType
} from 'common/modules/ReactShared';
import { FC } from 'react';

import CheckArrangeTextTask from './ArrangeTextTask';
import CheckAssignmentAITask from './AssignmentAITask';
import CheckAssignmentTask from './AssignmentTask';
import CheckFillInBlanksTask from './FillInBlanksTask';
import CheckFillInTableTask from './FillInTableTask';
import CheckInlineDropdownTask from './InlineDropdownTask';
import CheckMultipleChoiceTask from './MultipleChoiceTask';
import CheckTrueFalseTask from './TrueFalseTask';
import { ICheckTaskProps } from './types';

export type tCheckComponentType =
  | FC<ICheckTaskProps<IMultipleChoiceTask, IMultipleChoiceTaskSession>>
  | FC<ICheckTaskProps<IInlineDropdownTask, IInlineDropdownTaskSession>>
  | FC<ICheckTaskProps<ICheckTrueFalseTask, ITrueFalseTaskSession>>
  | FC<ICheckTaskProps<ICheckFillInBlanksTask, IFillInBlanksTaskSession>>
  | FC<ICheckTaskProps<IFillInTableTask, IFillInTableTaskSession>>
  | FC<ICheckTaskProps<IAssignmentTask, IAssignmentTaskSession>>
  | FC<ICheckTaskProps<IArrangeTextTask, IArrangeTextTaskSession>>;

export const checkTaskMap = new Map<tCheckTaskType['type'], tCheckComponentType>([
  ['Tasks::SelectText', CheckMultipleChoiceTask],
  ['Tasks::InlineDropdown', CheckInlineDropdownTask],
  ['Tasks::TrueFalse', CheckTrueFalseTask],
  ['Tasks::FillInBlanks', CheckFillInBlanksTask],
  ['Tasks::FillInTable', CheckFillInTableTask],
  ['Tasks::Essay', CheckAssignmentTask],
  ['Tasks::Audio', CheckAssignmentTask],
  ['Tasks::File', CheckAssignmentTask],
  ['Tasks::EssayAI', CheckAssignmentAITask],
  ['Tasks::ArrangeText', CheckArrangeTextTask]
]);
